// extracted by mini-css-extract-plugin
export default {"media-section":"MediaSection_media-section__yz-z6","grid":"MediaSection_grid__G4BQ+"};